import { Typography, useTheme, useMediaQuery } from '@mui/material';
import styled from 'styled-components';
import { containerPaddingPx } from './dialogStyledComponents';
import { Button } from '@act/storybook';
import { ReactNode } from 'react';

export const DialogMainContent = styled.div`
  padding: 12px ${containerPaddingPx}px;
  overflow: auto;
  margin: 0 -${containerPaddingPx}px;
`;

export interface DialogFooterAction {
  text: string;
  type?: 'button' | 'submit';
  callback?: () => unknown;
  disabled?: boolean;
  isPrimary?: boolean;
  variant?: 'contained' | 'outlined';
  isLeft?: boolean;
  icon?: ReactNode;
  trackingProps?: Record<string, string>;
}

export const ButtonFooterContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${props => (props.isMobile ? 'column' : 'row')};
  align-items: ${props => (props.isMobile ? 'stretch' : 'flex-start')};
  justify-content: ${props => (props.isMobile ? 'stretch' : 'flex-end')};

  padding: ${props => (props.isMobile ? '16px 24px' : '8px 24px')};
  margin: 0;
  gap: ${props => (props.isMobile ? '12px' : '8px')};
  border-top: solid 1px #dce4e8;

  .last-left {
    margin-right: ${props => (props.isMobile ? '0' : 'auto')};
  }

  /* Make buttons full width on mobile */
  button {
    width: ${props => (props.isMobile ? '100%' : 'auto')};
  }
`;

export const DialogFooter = (props: { actions?: DialogFooterAction[] }) => {
  const { actions } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const rightActions = actions.filter(a => !a.isLeft);
  const leftActions = actions.filter(a => !!a.isLeft);

  const getVariant = (action: DialogFooterAction) => {
    if (action?.isPrimary) {
      return 'contained';
    }
    if (action.variant) {
      return action.variant;
    }
    return null;
  };

  return (
    <ButtonFooterContainer isMobile={isMobile}>
      {leftActions.map((action, idx) => (
        <Button
          key={idx}
          className={idx + 1 === leftActions.length ? 'last-left' : ''}
          onClick={action.callback ? action.callback : null}
          type={action.type || 'button'}
          disabled={action.disabled ?? false}
          variant={getVariant(action)}
          {...action.trackingProps}
        >
          {action.icon}
          <Typography variant="labelLarge">{action.text}</Typography>
        </Button>
      ))}
      {rightActions.map((action, idx) => (
        <Button
          key={idx}
          onClick={action.callback ? action.callback : null}
          type={action.type || 'button'}
          disabled={action.disabled ?? false}
          variant={getVariant(action)}
          {...action.trackingProps}
        >
          {action.icon}
          <Typography variant="labelLarge">{action.text}</Typography>
        </Button>
      ))}
    </ButtonFooterContainer>
  );
};
